
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ksu1_r6xtl_9",
  "panel": "awsui_panel_1ksu1_r6xtl_44",
  "handle": "awsui_handle_1ksu1_r6xtl_48",
  "panel-content": "awsui_panel-content_1ksu1_r6xtl_52",
  "display-main-only": "awsui_display-main-only_1ksu1_r6xtl_65",
  "display-panel-only": "awsui_display-panel-only_1ksu1_r6xtl_68",
  "content": "awsui_content_1ksu1_r6xtl_74"
};
  